SharedPlayer = LP.module('SharedPlayer')

WebPageIFrameHandler =

  tryEmbeddingWebPage: ($slideElement, data) ->
    new Promise (resolve, reject) ->
      SharedPlayer.WebPageIFrameHandler._tryEmbeddingWebPage($slideElement, data, resolve, reject)

  _tryEmbeddingWebPage: ($slideElement, data, resolve, reject) ->
    handler = SharedPlayer.WebPageIFrameHandler
    return resolve() unless @_objectStatus(data.i).loading

    @_objectStatus(data.i)
    url = @._getResourceUrl(data)
    $slideElement.addClass('player-content-embedded-object-loader')
    pageLoader = document.createElement('object')
    pageLoader.id = "#object-loader-#{data.i}"
    pageLoader.className = "object-loader"
    pageLoader.innerHTML = ''
    pageLoader.data = url
    console.log('object loader is loading', url)
    loaderTimeout = 10000
    @_objectStatus(data.i).timeout = setTimeout(->
      return unless handler._objectStatus(data.i).loading
      handler._finishLoading($slideElement, data, pageLoader)
      console.log("object loader timeout")
      reject(new Error('timeout'))
    , loaderTimeout)
    pageLoader.onload = (e...) ->
      return unless handler._objectStatus(data.i).loading
      handler._finishLoading($slideElement, data, pageLoader)
      console.log("object loader onload", e)
      resolve(e)
    pageLoader.onerror = (e...) ->
      return unless handler._objectStatus(data.i).loading
      handler._finishLoading($slideElement, data, pageLoader)
      console.log("object loader onerror", e)
      reject(new Error(e))
    $slideElement.append(pageLoader)

  _getResourceUrl: (data) ->
    data.folderRedirectUrl || data.url

  _resetPageLoader: (pageLoader, $slideElement, data) ->
    return unless pageLoader?
    pageLoader.innerHTML = ''
    pageLoader.remove()

  _finishLoading: ($slideElement, data, pageLoader) ->
    if !pageLoader?
      pageLoader = @_findPageLoader($slideElement, data)
    status = @._objectStatus(data.i)
    status.loading = false
    clearTimeout(status.timeout)
    @._resetPageLoader(pageLoader, $slideElement, data)

  _objectStatus: (index) ->
    window.webpageLoaderStatus = {} unless window.webpageLoaderStatus?
    window.webpageLoaderStatus[index] = { loading: true } unless window.webpageLoaderStatus[index]?
    window.webpageLoaderStatus[index]

  _findPageLoader: ($slideElement, data) ->
    $slideElement.find("object#object-loader-#{data.i}")

SharedPlayer.WebPageIFrameHandler = WebPageIFrameHandler
